import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import BuildDeeperImage from './BuildDeeperImage'

const copy = {
  heading: `Build deeper customer relationships with Journeys`,
  description: (
    <>
      <CopyText.Description tag="p">
        With Journeys, users can orchestrate highly sophisticated customer journeys, at scale, to deliver meaningful
        personalization campaigns on any channel, and across any connected application.
      </CopyText.Description>
      <CopyText.Description tag="p">
        Segment’s customer journey management tool allows businesses to adjust the customer experience in real-time, to
        reflect consumers’ individual actions, preferences, and feedback. This allows teams to identify the most
        effective conversion drivers across the customer lifecycle.
      </CopyText.Description>
    </>
  ),
}

const BuildDeeper = () => (
  <SectionBase variant="2Col" reverse={true}>
    <SectionCopy>
      <CopyTextBase>
        <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
        {copy.description}
      </CopyTextBase>
    </SectionCopy>
    <Section.Contents>
      <BuildDeeperImage />
    </Section.Contents>
  </SectionBase>
)

const SectionCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`

export default BuildDeeper
